import { Box, Typography } from "@mui/material";
import './../../assets/scss/catLoader.scss';

export const CatLoader = () => {
    return (
        <div className="cat-loader">
            <Typography variant="body1" className="loading-text">Loading</Typography>
            <div className="cat">
                {Array.from({ length: 30 }).map(() => (
                    <Box className="cat__segment"></Box>
                ))}
            </div>
        </div>
    );
}
